// Requisitos de contraseña (iguales a la app móvil)
export const PASSWORD_MIN_LENGTH = 8;

export const validateNewPassword = (password) => {
  if (!password) return "Debe ingresar una nueva contraseña";
  if (password.length < PASSWORD_MIN_LENGTH)
    return `La contraseña debe tener al menos ${PASSWORD_MIN_LENGTH} caracteres`;
  if (!/[a-z]/.test(password) || !/[A-Z]/.test(password))
    return "La contraseña debe incluir mayúsculas y minúsculas";
  if (!/\d/.test(password))
    return "La contraseña debe incluir al menos un número";
  return null; // válida
};

export const getPasswordChecks = (password = "") => [
  { label: "Mínimo 8 caracteres", ok: password.length >= PASSWORD_MIN_LENGTH },
  { label: "Mayúsculas y minúsculas", ok: /[a-z]/.test(password) && /[A-Z]/.test(password) },
  { label: "Al menos un número", ok: /\d/.test(password) },
];
